import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import authService from 'auth/AuthService';
import Cookie from 'js-cookie';

const solicitudId = Cookie.get('solicitudId');

export const PublicRoutes = ({
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    component={
        (props) => (
            (!authService.isTokenValid())
                ? <Component {...props} />
                : (<Redirect to={`/apiv1/validation/${solicitudId}`} />)
        )
      }
  />
);

PublicRoutes.propTypes = {
  component: PropTypes.func.isRequired,
};
